import { htmlSafe } from "@ember/template";
import { classNames } from "@ember-decorators/component";
import { categoryBadgeHTML } from "discourse/helpers/category-link";
import dirSpan from "discourse/helpers/dir-span";
import discourseComputed from "discourse/lib/decorators";
import CategoryRowComponent from "select-kit/components/category-row";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const NoneCategoryRow = dt7948.c(class NoneCategoryRow extends CategoryRowComponent {
  badgeForCategory(category) {
    return htmlSafe(categoryBadgeHTML(category, {
      link: false,
      allowUncategorized: true,
      hideParent: true,
      ancestors: category?.predecessors
    }));
  }
  static {
    dt7948.n(this.prototype, "badgeForCategory", [discourseComputed("category")]);
  }
  static {
    setComponentTemplate(precompileTemplate("\n    {{#if this.category}}\n      <div class=\"category-status\" aria-hidden=\"true\">\n        {{this.badgeForCategory}}\n      </div>\n\n      {{#if this.shouldDisplayDescription}}\n        <div class=\"category-desc\" aria-hidden=\"true\">{{dirSpan this.descriptionText htmlSafe=\"true\"}}</div>\n      {{/if}}\n    {{else}}\n      {{htmlSafe this.label}}\n    {{/if}}\n  ", {
      strictMode: true,
      scope: () => ({
        dirSpan,
        htmlSafe
      })
    }), this);
  }
}, [classNames("none category-row")]);
export default NoneCategoryRow;